var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.primaryColorCss)?_c('custom-style',{attrs:{"css":_vm.primaryColorCss}}):_vm._e(),_c('custom-style',{attrs:{"css":_vm.customCss}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }